<div *ngFor="let groupMessage of groupCallList; let index = index"
     [title]="groupMessage?.subject.length > 20 ? groupMessage?.subject : ''"
     (click)="selectRoom(groupMessage)"
     [ngClass]="{'contact-active' : checkActive(index)}"
     class="contact" role="button">
  <div class=" group-list-image ml-2 mt-1 mb-1">
    <!--  <div class="contact-image-group">-->
    <div *ngIf="groupMessage?.members.length <= 4" class="text-sm-center">
      <div *ngFor="let member of groupMessage.members" class="mt-1" style="display: inline-block">
        <!--        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">-->
        <img class="contact-image" userAvatar [usercode]="member?.username" [title]="member?.fullname">
        <!--        </div>-->
      </div>
    </div>
    <div *ngIf="groupMessage?.members.length > 4">
      <div *ngFor="let member of groupMessage.members.slice(0, 3)" class="mt-1" style="display: inline-block">
        <!--        <div class="contact-online" [ngClass]="{'online': member?.joined,'offline': !member?.joined }">-->
        <img class="contact-image" userAvatar [usercode]="member?.username" [title]="member?.fullname">
        <!--        </div>-->
      </div>
      <div class="contact-plus"
           [title]="showNameMemberInGroup(groupMessage.members.slice(3, groupMessage.members.length))"
           [innerHTML]="'+' + groupMessage.members.slice(3, groupMessage.members.length).length">
      </div>
    </div>
  </div>
  <div class="contact-name ml-2 text-truncate" [title]="groupMessage?.subject.length > 20 ? groupMessage?.subject : '' ">{{shortNameGroup(groupMessage?.subject)}}</div>
</div>
